export const CONTAINER_STYLES = {
  position: 'relative',
  overflow: 'hidden',
};

export const ABSOLUTE_STYLES = {
  position: 'absolute',
  top: '0',
  right: '0',
  bottom: '0',
  left: '0',
};
